import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import Context from "@components/useContext/context";
import {
  bikeMMVIdentificationStarted,
} from "@analytics/bike/actions/mmv";
import { MMVPageProps } from "./types";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
  POLICY_STATUS_LABEL,
  BIKE_OD_POLICY_STATUS_TEXT,
  POLICY_EXPIRY_OPTIONS
  // BIKE_OD_POLICY_STATUS_TEXT
} from "@utils/bike/bikeConstants";

import * as Styles from "./styles";

import HybridWrapper, {
  LeftContainer,
  ContentContainer,
  CardContainer
} from "@components/common/standAlone/wrapper";
import BikeTwoPageJourneyProgressNav from "@components/Bike/twoPageJourney/BikeTwoPageJourneyProgressNav";
import ProgressSection from "@components/common/desktop/progressSection";
import { isBikeJourneyV2 } from "@utils/bike/journeyVersion";
import StickyFooter from "@components/common/standAlone/StickyFooter";
import Modal from "@components/common/standAlone/modal";
import YearSelector from "@components/Bike/mmv/mmvD2c/common/YearSelectorModal";
import {
  onBikeMakeModalClicked,
  onTermAndConClicked,
  tapBtnPolicyStatus,
  tapBtnRegYear
} from "segments/eventActions/bike/prequoteModule";
import { BikeOdRange } from "@utils/bike/bikeOdRange";
import FIELD_ERROR_MESSAGE from "@utils/errorMessages";
import { useShowPhoneNumberField } from "@utils/useShowPhoneNumberField";
import PhoneInput from "./PhoneInput";
const MMVInput = dynamic(() => import("./common/MMVInput"));

const PolicyExpirySelect = dynamic(() => import("./common/PolicyExpirySelect"));
interface YearOption {
  name: string;
  value: string;
}
export const generateRegistrationYears = (): YearOption[] => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20;
  const years: YearOption[] = [];

  years.push({
    name: currentYear.toString(),
    value: currentYear.toString()
  });

  for (let year = currentYear - 1; year >= startYear; year--) {
    years.push({
      name: year.toString(),
      value: year.toString()
    });
  }
  return years;
};
const MMVSelectorMobile: React.FC<MMVPageProps> = ({
  journeyVersion,
  showMMVPicker,
  registrationNumber,
  setShowMMVPicker,
  showRegYearPicker,
  setShowRegYearPicker,
  showExpiryPicker,
  disableExpiryPicker,
  setShowExpiryPicker,
  formMeta,
  formData,
  onVariantChange,
  onRegistrationYearChange,
  onPolicyExpiryChange,
  onSubmit,
  clearFormData,
  isNewBike,
  flow,
  vehicleDetails,
  onMobileNumberChange,
  mobileNumber,
  mobileErrors,
  title,
  fetchProposalSuccess,
  isLsiPortalFlow
}) => {
  const dispatch = useDispatch();
  const { isDesktop } = useContext(Context);
  const { checkOdOnly, isTpExpired, previous_policy_status } = useSelector(
    ({ proposalDataReducer }: any) => ({
      checkOdOnly: proposalDataReducer?.data?.check_od_only,
      isTpExpired: proposalDataReducer?.data?.isTpExpired,
      previous_policy_status: proposalDataReducer?.data?.policyStatus
    })
  );
  // const [showSearch, setShowSearch] = useState(true);

  const [hideExpiry, setHideExpiryPicker] = useState(false);
  const [bikeNoErr, setBikeNoErr] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [showBikeOdText, setShowBikeOdText] = useState(false);
  // function resetMMV(event?: MouseEvent) {
  //   if (event) event.stopPropagation();
  //   onVariantChange(null);
  // }
  console.log({ showBikeOdText });
  useEffect(() => {
    if (
      BikeOdRange(Number(formData.registrationYear?.value)) &&
      isTpExpired !== true
    ) {
      setShowBikeOdText(true);
    } else setShowBikeOdText(false);
  }, [formData.registrationYear?.value, checkOdOnly, isTpExpired]);

  useEffect(() => {
    if (
      previous_policy_status &&
      (previous_policy_status === "90-" || previous_policy_status === "0-90") &&
      !formData.policyExpiry &&
      !disableExpiryPicker
    ) {
      const selectedOption = POLICY_EXPIRY_OPTIONS.find(
        option => option.value === previous_policy_status
      );
      if (selectedOption) {
        onPolicyExpiryChange(selectedOption);
      }
    }
  }, [previous_policy_status, formData.policyExpiry, disableExpiryPicker, onPolicyExpiryChange]);

  useEffect(() => {
    try {
      if (flow && flow === "new") {
        setHideExpiryPicker(true);
      }
    } catch (e) {
      setHideExpiryPicker(false);
    }
  }, []);

  const { showPhoneNumberField } = useShowPhoneNumberField();

  // useEffect(() => {
  //   if (formData?.variant) {
  //     setShowSearch(false);
  //   }
  // }, [formData]);

  function editMMV() {
    clearFormData("not_my_bike");
  }

  const checkBikeNo = () => {
    if (formData?.variant?.verbose || searchText.length) {
      setBikeNoErr(false);
    } else {
      setBikeNoErr(true);
    }
  };

  useEffect(() => {
    setSearchText(formData.variant?.verbose || "");
  }, [formData]);

  // useEffect(() => {
  //   const disabled =
  //     !formData.variant ||
  //     !!mobileErrors ||
  //     (mobileNumber === "" && isNewBike) ||
  //     !formData.registrationYear ||
  //     (formData.registrationYear?.value !== currentYear &&
  //       !formData.policyExpiry);
  //   setSubmitButtonDisabled(disabled);
  // }, [formData, mobileErrors]);

  // function checkNewBike(isNewBike: boolean) {
  //   if (!isNewBike) {
  //     setShowRegYearPicker(true);
  //   }
  // }

  function handleInputClick() {
    let screen = "bike_aadrilla_failure_screen";
    if (vehicleDetails?.variantId) {
      screen = "bike_aadrilla_success_screen";
    }
    if (flow === "dkbn") {
      screen = "dont_know_bike_number_screen";
    }
    if (flow === "new") {
      screen = "new_bike_screen";
    }
    dispatch(
      bikeMMVIdentificationStarted({ reg_no: registrationNumber }, screen)
    );
    dispatch(onBikeMakeModalClicked());
    setShowMMVPicker(true);
  }

  // let disabled = true;
  // useEffect(() => {
  //   disabled =
  //     formMeta.phone ||
  //     formMeta.policyExpiry ||
  //     formMeta.registrationYear ||
  //     formMeta.variant;
  //   console.log("FormMetaa disbaled", disabled);
  // }, [formMeta]);

  return (
    <>
      <HybridWrapper>
        <LeftContainer>
          {isBikeJourneyV2(journeyVersion) ? (
            <BikeTwoPageJourneyProgressNav activeStep="bike_details" />
          ) : (
            <ProgressSection
              steps={[
                { name: "Bike details", status: "progress" },
                { name: "Select plan", status: "pending" },
                { name: "Select Add-ons", status: "pending" },
                { name: "Personal details", status: "pending" },
                { name: "Checkout", status: "pending" }
              ]}
            />
          )}
        </LeftContainer>
        <ContentContainer>
          <CardContainer>
            <Flex
              styles={
                isDesktop
                  ? { flexDirection: "column", width: "90%" }
                  : { flexDirection: "column" }
              }
            >
              <Styles.Heading>{title}</Styles.Heading>

              <Styles.FormContainer>
                <MMVInput
                  showMMVPicker={showMMVPicker}
                  setShowMMVPicker={setShowMMVPicker}
                  // searchIconClick={formData.variant?.verbose ? resetMMV : null}
                  onChange={onVariantChange}
                  onClick={() => {
                    handleInputClick();
                    formData.variant?.verbose ? editMMV() : null;
                  }}
                  value={formData.variant?.verbose}
                  bikeNoErr={bikeNoErr}
                  setBikeNoErr={setBikeNoErr}
                  searchText={searchText}
                  setSearchText={setSearchText}
                />

                {/* {!disableExpiryPicker && (
                  <Styles.StyledBikeFormitem
                    hideExpiry={hideExpiry}
                    value={formData.registrationYear?.name}
                    icon={require("@public/images/bike-cake-icon.svg?url")}
                    iconAlt="Registration icon"
                    label={REGISTRATION_YEAR_LABEL}
                    placeholder="Select registration year"
                    error={formMeta.registrationYear}
                    onClick={() => checkNewBike(isNewBike)}
                    hideCaret
                    hideKeyboard
                  />
                )} */}

                {!hideExpiry &&
                  (fetchProposalSuccess ||
                    formData?.registrationYear?.name) && (
                    <div>
                      <Styles.StyledBikeFormitem
                        value={formData?.registrationYear?.name || ""}
                        placeholder="Registration year"
                        error={formMeta.registrationYear}
                        onClick={() => setShowRegYearPicker(true)}
                        hideCaret
                        hideKeyboard
                      />

                      <YearSelector
                        showModal={showRegYearPicker}
                        setShowModal={setShowRegYearPicker}
                        yearOptions={generateRegistrationYears()}
                        activeYear={formData?.registrationYear?.name || ""}
                        isDesktop={isDesktop}
                        setActiveYear={selectedYear => {
                          setShowRegYearPicker(false);
                          dispatch(tapBtnRegYear());
                          onRegistrationYearChange({
                            name: selectedYear.name,
                            buttonId: selectedYear.name,
                            value: selectedYear.value
                          });
                        }}
                      />

                      {formMeta.registrationYear && (
                        <Styles.Error>
                          {FIELD_ERROR_MESSAGE.regdYear.required}
                        </Styles.Error>
                      )}
                    </div>
                  )}

                {!disableExpiryPicker && (
                  <>
                    <Styles.StyledBikeFormitem
                      value={formData.policyExpiry?.name}
                      icon={require("@public/images/bike-policy-icon.svg?url")}
                      iconAlt="Current policy icon"
                      label={POLICY_STATUS_LABEL}
                      placeholder={
                        formData.policyExpiry?.name
                          ? "Current policy status"
                          : "Select current policy status"
                      }
                      error={formMeta.policyExpiry}
                      onClick={() => {
                        setShowExpiryPicker(true);
                        dispatch(tapBtnPolicyStatus());
                      }}
                      hideCaret
                      hideKeyboard
                    />
                    {formMeta.policyExpiry && (
                      <Styles.Error>
                        {FIELD_ERROR_MESSAGE.policyStatus.required}
                      </Styles.Error>
                    )}
                    {showBikeOdText && (
                      <div
                        style={{
                          height: "16px",
                          marginTop: "5px",
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "16px",
                          color: "#5B5675"
                        }}
                      >
                        {BIKE_OD_POLICY_STATUS_TEXT}
                      </div>
                    )}
                  </>
                )}
                {!isLsiPortalFlow && showPhoneNumberField && (
                  <>
                    <PhoneInput
                      mobileNumber={mobileNumber}
                      mobileErrors={mobileErrors}
                      onMobileNumberChange={onMobileNumberChange}
                    />

                    <Styles.ErrLabel>{mobileErrors}</Styles.ErrLabel>

                    {isDesktop && (
                      <Styles.PhonInfoLable>
                        Required for sharing quote and policy details
                      </Styles.PhonInfoLable>
                    )}
                  </>
                )}

                {/* {isNewBike && !isDesktop && (
                  <Styles.TermConText>
                    By proceeding, you agree to the{" "}
                    <span>
                      <a
                        onClick={() => dispatch(onTermAndConClicked())}
                        href={`${process.env.HOST_URL}/terms-and-conditions/`}
                        target="_blank"
                      >
                        Terms & Conditions
                      </a>
                    </span>
                  </Styles.TermConText>
                )} */}

                {!isNewBike && formData?.ncb && (
                  <Styles.StyledBikeFormitem
                    value={`${formData.ncb}%`}
                    placeholder="New NCB value"
                    readOnly={true}
                    hideCaret={true}
                    hideKeyboard={true}
                    hideIcon={true}
                    disabled={true}
                    inputStyles={{
                      backgroundColor: "var(--Neutral-N50, #F8F7FC)",
                      color: "#938f96 !important"
                    }}
                  />
                )}
              </Styles.FormContainer>
            </Flex>
          </CardContainer>
        </ContentContainer>
      </HybridWrapper>

      {/* {isDesktop && (
        <DesktopStickyFoooter
          price={""}
          hidePriceSection
          showtermAndCon={isDesktop && isNewBike}
          ctaText="View plans"
          clickHandler={() => {
            onSubmit();
            checkBikeNo();
          }}
          onTermAndConClick={() => dispatch(onTermAndConClicked())}
        />
      )}

      {!isDesktop && (
        <MobileStickyFooter
          price={""}
          hidePriceSection
          ctaText="View plans"
          clickHandler={() => {
            onSubmit();
            checkBikeNo();
          }}
        />
      )} */}

      <StickyFooter
        price={""}
        hidePriceSection
        showtermAndCon={true}
        ctaText="View plans"
        clickHandler={() => {
          onSubmit();
          checkBikeNo();
        }}
        onTermAndConClick={() => dispatch(onTermAndConClicked())}
      />

      {/* <Modal
        modalHeading={"Select year"}
        showModal={showRegYearPicker}
        setShowModal={setShowRegYearPicker}
      >
        <RegistrationYearSelect
          value={formData.registrationYear}
          onOptionClick={onRegistrationYearChange}
        />
      </Modal> */}

      <Modal
        modalHeading={"Current policy status"}
        showModal={showExpiryPicker}
        setShowModal={setShowExpiryPicker}
        styles={
          isDesktop
            ? {
              width: "472px"
            }
            : {}
        }
      >
        <div style={{ marginTop: "1rem" }}>
          <PolicyExpirySelect
            value={formData.policyExpiry}
            onOptionClick={onPolicyExpiryChange}
          />
        </div>
      </Modal>
    </>
  );
};

export default MMVSelectorMobile;